import { render, staticRenderFns } from "./PolicyCaseLibrary.vue?vue&type=template&id=153ef2fa"
import script from "./PolicyCaseLibrary.vue?vue&type=script&lang=js"
export * from "./PolicyCaseLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports